"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var router_1 = require("@angular/router");
var common_1 = require("@angular/common");
var entity_name_provider_service_1 = require("../../../../../shared/services/api/entity-name-provider.service");
var operators_1 = require("rxjs/operators");
var dynamic_navigation_helper_1 = require("../../../common/utils/dynamic-navigation-helper");
var url_and_query_params_1 = require("../../../../../shared/utils/url-and-query-params");
var portfolio_header_helper_service_1 = require("../../../common/service/portfolio-header-helper.service");
var of_1 = require("rxjs/observable/of");
/**
 * Header for dynamically defined portfolios.
 */
var PortfolioHeaderComponent = /** @class */ (function () {
    function PortfolioHeaderComponent(route, entityNameProviderService, location, portfolioHeaderHelperService) {
        this.route = route;
        this.entityNameProviderService = entityNameProviderService;
        this.location = location;
        this.portfolioHeaderHelperService = portfolioHeaderHelperService;
        this.portfolioConfigsChange = new core_1.EventEmitter();
        this.isSingleCategoryPortfolio = false;
        this.isIndependentPortfolio = false;
        this.menuOpened = false;
    }
    PortfolioHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.initRouteVariables();
        this.isIndependentPortfolio = !this.subCategoryId && !this.rootEntityId;
        this.currentCategoryId = this.subCategoryId || this.mainCategoryId;
        this.rootCategory$ = !this.isIndependentPortfolio ? of_1.of(this.mainCategoryId) :
            this.portfolioHeaderHelperService.loadCurrentRootCategory(this.currentCategoryId);
        this.portfolioDefinitions$ = this.rootCategory$.pipe(operators_1.switchMap(function (rootCategory) { return _this.loadAvailablePortfolios(rootCategory); }));
        if (!this.isIndependentPortfolio) {
            // root entity name field in header
            this.rootEntityName$ = this.entityNameProviderService.getEntityName(this.mainCategoryId, this.rootEntityId)
                .pipe(operators_1.publishReplay(1), operators_1.refCount());
        }
    };
    PortfolioHeaderComponent.prototype.onBackEvent = function () {
        this.location.back();
    };
    PortfolioHeaderComponent.prototype.onCreateNew = function () {
        var _this = this;
        if (!this._createSubscription || this._createSubscription.closed) {
            this._createSubscription = this.rootCategory$.pipe(operators_1.switchMap(function (rootCategoryId) {
                return _this.portfolioHeaderHelperService.createNewEntity(_this.currentCategoryId, rootCategoryId, _this.rootEntityId);
            }), operators_1.take(1)).subscribe();
        }
    };
    PortfolioHeaderComponent.prototype.openCloseMenu = function () {
        this.menuOpened = !this.menuOpened;
    };
    PortfolioHeaderComponent.prototype.selectPortfolio = function (portfolioDefinition) {
        if (this.selectedPortfolio !== portfolioDefinition) {
            this.selectedPortfolio = portfolioDefinition;
            this.title = this.selectedPortfolio.title;
            this.portfolioConfigsChange.emit(portfolioDefinition);
        }
    };
    PortfolioHeaderComponent.prototype.initRouteVariables = function () {
        this.subCategoryId = dynamic_navigation_helper_1.getPropertyFromUrl(url_and_query_params_1.UrlAndQueryParams.categoryId, this.route);
        this.mainCategoryId = dynamic_navigation_helper_1.getPropertyFromUrl(url_and_query_params_1.UrlAndQueryParams.rootCategoryId, this.route);
        this.rootEntityId = dynamic_navigation_helper_1.getNumericPropertyFromUrl(url_and_query_params_1.UrlAndQueryParams.rootEntityId, this.route);
    };
    PortfolioHeaderComponent.prototype.loadAvailablePortfolios = function (rootCategory) {
        var _this = this;
        return this.portfolioHeaderHelperService.loadAvailablePortfolios(this.currentCategoryId, rootCategory, this.rootEntityId)
            .pipe(operators_1.tap(function (definedPortfolios) {
            if (definedPortfolios && definedPortfolios.length) {
                _this.selectedPortfolio = definedPortfolios[0];
                _this.title = _this.title || definedPortfolios[0].title;
                _this.portfolioConfigsChange.emit(definedPortfolios[0]);
            }
        }));
    };
    PortfolioHeaderComponent.prototype.ngOnDestroy = function () {
        this._createSubscription && this._createSubscription.unsubscribe();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Observable_1.Observable)
    ], PortfolioHeaderComponent.prototype, "hasCreatePermission$", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PortfolioHeaderComponent.prototype, "title", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], PortfolioHeaderComponent.prototype, "portfolioConfigsChange", void 0);
    PortfolioHeaderComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-portfolio-header',
            styles: [require('./portfolio-header.component.css')],
            template: require('./portfolio-header.component.html')
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute,
            entity_name_provider_service_1.EntityNameProviderService,
            common_1.Location,
            portfolio_header_helper_service_1.PortfolioHeaderHelperService])
    ], PortfolioHeaderComponent);
    return PortfolioHeaderComponent;
}());
exports.PortfolioHeaderComponent = PortfolioHeaderComponent;
//# sourceMappingURL=portfolio-header.component.js.map